const toPersonalDetails = (raw, email) => {
  return {
    dateOfBirth: raw?.dateOfBirth ?? "",
    phone: raw?.phone ?? "",
    email: email ?? ""
  };
};
const toBillingAddress = (raw) => {
  return {
    additionalStreetInfo: raw?.additionalStreetInfo ?? "",
    additionalAddressInfo: raw?.additionalAddressInfo ?? "",
    city: raw?.city ?? "",
    company: raw?.company ?? "",
    country: raw?.country ?? "",
    postalCode: raw?.postalCode ?? "",
    prefix: raw?.prefix ?? "",
    region: raw?.region ?? "",
    streetName: raw?.streetName ?? "",
    streetNumber: raw?.streetNumber ?? "",
    firstName: raw?.firstName ?? "",
    lastName: raw?.lastName ?? "",
    middleName: raw?.middleName ?? "",
    salutation: raw?.salutation ?? ""
  };
};
export {
  toBillingAddress,
  toPersonalDetails
};
//# sourceMappingURL=user-details-to-shipping-summary-mapper.js.map
